import axios from '@/utils/request'
import base from './base'
import qs from 'qs'

export function accountApplyList(data) { return axios.post(`${base.url}/business/accountApply/list`, qs.stringify(data)) }
export function accountApplyStats() { return axios.post(`${base.url}/business/accountApply/stats`) }
export function accountApplyDetail(ids) { return axios.post(`${base.url}/business/accountApply/detail`, qs.stringify({ ids })) }
export function accountApplyReview(data) { return axios.post(`${base.url}/business/accountApply/review`, qs.stringify(data)) }
// 批量审核：ids 传逗号分隔的客户ID字符串（和导出接口一致），返回 { successCount, failCount, failures }
export function accountApplyReviewBatch(data) { return axios.post(`${base.url}/business/accountApply/reviewBatch`, qs.stringify(data)) }
export function accountApplyExport(data) { return axios.post(`${base.url}/business/accountApply/export`, qs.stringify(data), { responseType: 'blob' }) }
